var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"import-fail"},[_c('h2',{staticClass:"icon-alert"},[_vm._v(" 数据导入失败 ")]),_c('p',[_c('a',{on:{"click":_vm.restart}},[_vm._v("重新导入")])])])}
var staticRenderFns = []

export { render, staticRenderFns }